<template>
    <div class="card">
        <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
                <i class="material-icons">find_in_page</i>
            </div>
            <h4 class="card-title ">Histórico</h4>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Usuário</th>
                            <th>Data e Hora</th>
                            <th>Ações</th>
                            <th>Documentos</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="histories.length > 0"
                            v-for="iterator in histories"
                            :key="iterator.id">
                            <td>{{ iterator.user.name }}</td>
                            <td>{{ iterator.created_at | moment("DD/MM/YYYY") }} às {{ iterator.created_at | moment("HH:mm") }}</td>
                            <td 
                                v-html="iterator.modifications"></td>
                            <td>
                                <div v-for="(document, index) in iterator.contract_history_documents">
                                    <a href="javascript:;" v-on:click="download(document.file)">
                                        {{ `Baixar ${document.description}` }}
                                    </a>
                                </div>
                            </td>
                        </tr>
                        <tr v-show="histories.length==0">
                            <td colspan="7">Nenhum histórico encontrado!</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        histories() {
            if (this.$store.state.contracts.item && this.$store.state.contracts.item.contract_histories && this.$store.state.contracts.item.contract_histories.length > 0) {
                console.log(this.$store.state.contracts.item.contract_histories)
                return this.$store.state.contracts.item.contract_histories;
            }
            return [];
        }
    },
    created() {
        this.getContract();
    },
    methods: {
        download(url) {
            window.open(url, "_blank");
        },
        downloadAndConvertToBase64(url) {
            return new Promise((resolve, reject) => {
                // Baixar o PDF da URL usando fetch
                fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Erro ao baixar o arquivo');
                    }
                    return response.blob();
                })
                .then(blob => {
                    // Ler o conteúdo do PDF como ArrayBuffer
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);

                    // Converte o conteúdo do PDF para base64 quando a leitura estiver completa
                    reader.onloadend = () => {
                    const base64data = reader.result;
                    // Obtém apenas os dados após a vírgula (base64)
                    const base64 = base64data.split(',')[1];
                    resolve(base64);
                    };

                    reader.onerror = () => {
                    reader.abort();
                    reject(new DOMException('Erro ao ler o arquivo.'));
                    };
                })
                .catch(error => {
                    console.error('Ocorreu um erro:', error);
                    reject(error);
                });
            });
        },
        sairModal() {
            this.$root.$emit("updateList");
            this.$root.$emit("hideModal");
        },
        async getContract() {
            this.$root.$emit("onLoading");

            await this.$store.dispatch(
                "contracts/get",
                this.$route.params.id
            );

            this.$root.$emit("onLoading");
        },
    }
};
</script>